import { render, staticRenderFns } from "./ScreensaverNextFlyer2.vue?vue&type=template&id=38a33cc7&scoped=true"
import script from "./ScreensaverNextFlyer2.vue?vue&type=script&lang=js"
export * from "./ScreensaverNextFlyer2.vue?vue&type=script&lang=js"
import style0 from "./ScreensaverNextFlyer2.vue?vue&type=style&index=0&id=38a33cc7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a33cc7",
  null
  
)

/* custom blocks */
import block0 from "@/locales/global.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Fabdl-party%2Fweb%2Fwebapp%2Fsrc%2Fpages%2Fscreensaver%2FScreensaverNextFlyer2.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports